export default __webpack_public_path__ + "static/media/pencil.97e95ab1.png";